<template>
  <layout-basic>
    <page-hero
      title="Real Businesses. Real Results."
      lead="See how organisations are transforming onboarding, compliance and employee development."
    />

    <section class="demo-video-section">
      <v-container style="max-width: 960px">
        <demo-video video-key="stories" />
      </v-container>
    </section>

    <section class="stories-sectors">
      <v-container>
        <h2 class="font-sora stories-sectors__title">Customer stories by sector</h2>
        <p class="stories-sectors__note">
          We’re expanding these sector stories with full case studies. The cards
          below are placeholders for what’s coming next.
        </p>
        <div class="stories-sectors__grid">
          <div
            v-for="sector in sectors"
            :key="sector"
            class="stories-sectors__card"
          >
            <strong>{{ sector }}</strong>
            <span>Case study coming soon</span>
          </div>
        </div>
      </v-container>
    </section>

    <standard-cta
      title="Could your business be next?"
      lead="Watch the demo or experience IMPROVE for yourself."
    />
  </layout-basic>
</template>

<script>
import LayoutBasic from '@/layouts/Dashboard';
import PageHero from '@/components/marketing/PageHero.vue';
import StandardCta from '@/components/marketing/StandardCta.vue';
import DemoVideo from '@/components/DemoVideo.vue';
import { marketingPageMeta } from '@/utils/marketingPage';

export default {
  name: 'CustomerStories',
  components: {
    LayoutBasic,
    PageHero,
    StandardCta,
    DemoVideo,
  },
  metaInfo() {
    return marketingPageMeta({
      title: 'Real Businesses. Real Results. | IMPROVE',
      description:
        'See how organisations are transforming onboarding, compliance and employee development with IMPROVE.',
      path: '/customer-stories',
    });
  },
  data() {
    return {
      sectors: [
        'Manufacturing',
        'Engineering',
        'Professional Services',
        'Charity',
        'Logistics',
      ],
    };
  },
};
</script>

<style scoped>
.stories-sectors {
  padding: 32px 0 48px;
  background: #f7f9fb;
}

.stories-sectors__title {
  text-align: center;
  color: var(--brand-navy, #002458);
  font-size: 28px;
  font-weight: 700;
  margin: 0 0 12px;
}

.stories-sectors__note {
  text-align: center;
  max-width: 560px;
  margin: 0 auto 28px;
  color: var(--brand-grey, #6b7280);
  font-size: 15px;
  line-height: 1.5;
}

.stories-sectors__grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  max-width: 980px;
  margin: 0 auto;
}

.stories-sectors__card {
  display: flex;
  flex-direction: column;
  gap: 6px;
  background: #fff;
  border: 1px solid #e6ebf1;
  border-radius: 12px;
  padding: 22px 18px;
  color: var(--brand-navy, #002458);
}

.stories-sectors__card strong {
  font-size: 17px;
}

.stories-sectors__card span {
  color: var(--brand-grey, #6b7280);
  font-size: 14px;
}

@media screen and (max-width: 900px) {
  .stories-sectors__grid {
    grid-template-columns: 1fr;
  }
}
</style>
